import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.jsx'
import { registerServiceWorker } from './registerServiceWorker.js'

// Order matters and is not alphabetical:
//   tokens.css       — the design system, pasted in as authored. Defines
//                      every custom property the other files read, plus the
//                      reduced-motion block and the never-removed focus ring.
//   fonts.css        — @font-face for the self-hosted families tokens.css
//                      names.
//   app.css          — components. Semantic aliases only, never the raw
//                      ramps.
//   watch-archive.css — V2-2b's own stylesheet (Everything, and reviews on
//                      the title page), kept separate from app.css so this
//                      lane cannot collide with V2-8b's own concurrent edit
//                      to that file's watch section — see its own header.
//                      Loaded last; it only adds new selectors, so order
//                      relative to app.css does not otherwise matter.
//   watch-leaderboards.css — V2-5c's own stylesheet (the Leaderboards view
//                      and the profile's stat tiles), the identical
//                      separate-file precedent watch-archive.css set —
//                      see its own header. Also only adds new selectors.
//   watch-goated.css — V2-8c's own stylesheet (the Goated screen: what the
//                      group loved, and everyone's top three), the same
//                      separate-file precedent, for the same reason (this
//                      lane does not own app.css either).
import './styles/tokens.css'
import './styles/fonts.css'
import './styles/app.css'
import './styles/watch-archive.css'
import './styles/watch-leaderboards.css'
import './styles/watch-goated.css'

const container = document.getElementById('root')
if (!container) {
  // index.html is in this repo and cannot lose #root by accident — but if it
  // ever did, React's own message is "Target container is not a DOM element",
  // which sends you looking at React. This one sends you to the file.
  throw new Error('index.html is missing <div id="root"> — nothing can be mounted')
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)

registerServiceWorker()
